export default __webpack_public_path__ + "static/media/sponsor-sauvage.11868e28.png";